export const appName = "BPay";

export const appData = {
  hero: {
    title: "Your partner in running a successful business",
    description:
      "A powerful tool that simplifies daily payments, transaction tracking, and recurring income management for bike owners, helping you to stay organized and grow your business.",
  },
  features: {
    title:
      "BPay Features",
    options: [
      {
        feature: "Overview at a Glance",
        description:
          "Our Dashboard gives you a real-time snapshot of your bike business, displaying key metrics, recent transactions, and bike status updates. It’s designed to help you quickly assess performance and make informed decisions. Stay on top of your operations with ease, all in one place.",
      },
      {
        feature: "Efficient Bike Management",
        description:
          "The Bikes feature lets you manage your fleet, track bike availability, and monitor bike performance. Easily assign bikes to drivers, update statuses, and keep track of important details like registration and usage. Simplify your fleet management for smoother operations.",
      },
      {
        feature: "Driver Management Made Simple",
        description:
          "Easily manage your bike drivers, track their payment histories, and assign bikes. This feature helps you maintain an up-to-date driver roster with simple tools for monitoring their performance and ensuring timely payments. Keep your team organized and efficient.",
      },
      {
        feature: "Seamless Payment Tracking",
        description:
          "The Payments feature allows you to track and manage daily payments from bike drivers, ensuring accuracy and transparency. With easy-to-read reports and automatic updates, you can stay on top of all financial transactions and never miss a payment.",
      },
      {
        feature: "Maintain Your Fleet with Ease",
        description:
          "Track and manage regular maintenance for your bikes to ensure they are always in top condition. The Bike Maintenance feature allows you to set reminders, log service records, and schedule repairs, ensuring your fleet stays reliable and operational.",
      },
    ],
  },
  whyUs: {
    title: "Offline USSD Portal for Bike Drivers",
    description:
      "BPay’s USSD portal allows bike drivers to submit daily payments easily and securely, even without an internet connection or a smartphone. Designed with accessibility in mind, it offers a simple, fast, and reliable way for drivers to manage their payments from any device. This seamless process ensures that every driver can stay on top of their payments, no matter where they are. With BPay’s USSD portal, we make managing your payments easier, empowering drivers to focus on what matters most—delivering service.",
  },
  pricing: [
    {
      price: "RWF 10,000",
      title: "1 Bike Owners",
      description: "Package for Owners with 1 Bike",
      features: [
        "Subscription-Based Pricing",
        "Designed for small-scale bike owners",
        "Exclusive support for single-bike management",
      ],
    },
    {
      price: "RWF 7,000",
      title: "2 – 9 Bikes Owners",
      description: "Package for Owners with 2 – 9 Bikes",
      features: [
        "Subscription-Based Pricing",
        "Optimized for medium-sized operations",
        "Manage up to 9 bikes seamlessly",
      ],
    },
    {
      price: "RWF 5,000",
      title: "10+ Bikes Owners",
      description: "Package for Owners with 10+ Bikes",
      features: [
        "Subscription-Based Pricing",
        "Tailored for enterprise-level needs",
        "Handle 10 or more bikes effortlessly",
      ],
    },
  ],
  faqs: [
    {
      question: "What is BPay?",
      answer:
        "BPay is a platform designed to help bike owners manage their businesses easily. It simplifies tracking payments from drivers, handling recurring fees, and keeping records, making daily operations more efficient.",
    },
    {
      question: "How does BPay benefit bike owners?",
      answer:
        "BPay makes it easy for bike owners to track how much drivers pay, manage payments to bike owners, monitor bike performance, and handle maintenance records. It gives you full control of your bike business in one place.",
    },
    {
      question: "How does BPay simplify managing payments from drivers?",
      answer:
        "BPay automates payment tracking, ensuring drivers’ payments are logged accurately. It reduces the hassle of manual calculations and keeps a clear record of payments for transparency.",
    },
    {
      question: "How can I track the performance of my bikes with BPay?",
      answer:
        "BPay provides reports to help you monitor your business performance. You can track how your bikes are doing monthly and yearly, so you know exactly how much you’re earning and where to improve.",
    },
    {
      question: "Can BPay help with bike maintenance records?",
      answer:
        "Yes! BPay lets you record and track bike maintenance schedules, ensuring your bikes stay in good condition and reducing unexpected repair costs.",
    },
    {
      question: "What payment options does BPay support?",
      answer:
        "BPay supports payments through MTN Mobile Money, Airtel Money, Visa, and Mastercard, making it easy for drivers to pay you no matter what platform they use.",
    },
    {
      question: "Is BPay affordable for bike owners?",
      answer:
        "Yes! BPay offers flexible subscription plans based on the number of bikes you own. Plans start at RWF 10,000 per month for one bike and reduce as you add more bikes.",
    },
    {
      question: "How does BPay help bike owners manage recurring payments?",
      answer:
        "BPay is designed to handle recurring payments seamlessly. It tracks daily or monthly payments from drivers, ensuring you’re always updated and reducing disputes or missed payments.",
    },
    {
      question: "Can BPay help me grow my bike business?",
      answer:
        "Absolutely! BPay not only simplifies your daily operations but also provides insights into your business performance, helping you make better decisions and grow your profits.",
    },
    {
      question: "How easy is it to use BPay?",
      answer:
        "BPay is very user-friendly! Whether you’re managing a single bike or a fleet, the platform is designed to be simple to use, saving you time and effort.",
    },
  ],
};

export const menuItems = [
  { label: "Home", link: "#home" },
  { label: "BPay Demo", link: "#bpaydemo" },
  { label: "Features", link: "#features" },
  { label: "USSD Portal", link: "#driverussd" },
  { label: "Pricing", link: "#pricing" },
  { label: "FAQs", link: "#faqs" },
];
